import type { AnyObject, TestConfig } from 'yup';

import i18n from '@/i18n';
import {
  englishNumberRegex,
  isValidIranianNationalCode,
  numberRegex,
  passwordRegex,
  persianCharactersRegex,
  yupValidator,
} from '@/utils';

export const passwordValidator = ({
  label,
}: {
  label: string;
}): yupValidator.StringSchema<string> =>
  yupValidator
    .string()
    .required()
    .test(
      'no-persian-character',
      i18n.t('messages.switchKeyboardToEnglish'),
      (value) => !persianCharactersRegex.test(value)
    )
    .matches(passwordRegex, { message: i18n.t('messages.passwordIsWeak') })
    .label(label);

export const samePasswordValidator = ({
  label,
}: {
  label: string;
}): yupValidator.StringSchema<string> =>
  yupValidator
    .string()
    .label(label)
    .oneOf(
      [yupValidator.ref('password')],
      i18n.t('messages.passwordsAreNotIdentical')
    )
    .required();

export const nationalCodeValidator = ({
  label,
}: {
  label: string;
}): yupValidator.StringSchema<string> =>
  yupValidator
    .string()
    .label(label)
    .required()
    .test(
      'no-persian-character',
      i18n.t('messages.switchKeyboardToEnglish'),
      (value) => !persianCharactersRegex.test(value || '')
    )
    .test(
      'national-code-regex',
      i18n.t('messages.invalidNationalCode'),
      (value) => !value || (Boolean(value) && isValidIranianNationalCode(value))
    );

export const englishOnlyParams: TestConfig<
  number | string | undefined,
  AnyObject
> = {
  name: 'no-persian-character',
  message: i18n.t('messages.switchKeyboardToEnglish'),
  test: (value: number | string | undefined): boolean =>
    !persianCharactersRegex.test(value?.toString() || ''),
};

export const numberValidator = ({
  label,
}: {
  label: string;
}): yupValidator.StringSchema<string> =>
  yupValidator
    .string()
    .required()
    .matches(numberRegex, { message: label + i18n.t('messages.mustBeNumber') })
    .matches(englishNumberRegex, i18n.t('messages.mustBeEnglishNumber'))
    .label(label);
